import { BaseEnvironmentInterface } from 'src/env-interface';
import baseUrls from './main-urls';
import { resolveAppEnvironment, resolveEnvColors } from './resolve-app-environment';

const envColors = resolveEnvColors({
  localColor: import.meta.env?.NG_APP_LOCAL_COLOR,
  devColor: import.meta.env?.NG_APP_DEV_COLOR,
  stgColor: import.meta.env?.NG_APP_STG_COLOR,
});

export const environment: BaseEnvironmentInterface = {
  ...baseUrls.list,
  production: false,
  version: baseUrls.version + '-stg',
  baseUrlLocal: import.meta.env.NG_APP_API_URL_BASE_STG,
  buildDate: '04.11.2026T18:56:07',
  appEnv: resolveAppEnvironment(import.meta.env?.NG_APP_ENV, 'staging'),
  ...envColors,
};
